"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Autocomplete_1 = require("@material-ui/lab/Autocomplete");
var core_1 = require("@material-ui/core");
var GenericInput_1 = require("../../../../common/components/genericInput/GenericInput");
var GenericInputStyles_1 = require("../../../../common/components/genericInput/GenericInputStyles");
var icons_1 = require("@material-ui/icons");
var usePlatformConfig_1 = require("../../../../../../../checkout_lite/src/common/react/usePlatformConfig");
var AutocompleteInput = function (_a) {
    var formData = _a.formData;
    var _b;
    var label = formData.label, required = formData.required, id = formData.id, value = formData.value, options = formData.options, onChange = formData.onChange, placeholder = formData.placeholder, schema = formData.schema;
    var styles = GenericInputStyles_1.default();
    var _c = react_1.useState(false), dropdownOpened = _c[0], setDropdownOpen = _c[1];
    var defaultValue = options.enumOptions.find(function (option) { return option.value === value; });
    var filterOptions = Autocomplete_1.createFilterOptions({
        matchFrom: 'any',
        limit: 50,
    });
    var checkout = usePlatformConfig_1.default().platformConfig.checkout;
    var showDropdownIcon = (checkout || {}).showDropdownIcon;
    var handleOnChange = function (option) {
        var _a;
        onChange((_a = option) === null || _a === void 0 ? void 0 : _a.value);
        setDropdownOpen(false);
    };
    var handleBodyScroll = function () {
        if (dropdownOpened) {
            setDropdownOpen(false);
        }
    };
    var autocompleteRef = react_1.useRef(null);
    var handleCloseDropdownOnPageClick = function (event) {
        if (autocompleteRef.current && !autocompleteRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };
    react_1.useEffect(function () {
        var body = document.body;
        var scrollbarWidth = window.innerWidth - body.clientWidth;
        body.style.overflow = dropdownOpened ? 'hidden' : 'auto';
        body.style.paddingRight = dropdownOpened ? scrollbarWidth + "px" : 'unset';
        body.addEventListener('scroll', handleBodyScroll);
        document.addEventListener('click', handleCloseDropdownOnPageClick);
        return function () {
            body.style.overflow = 'auto';
            body.style.paddingRight = 'unset';
            body.removeEventListener('scroll', handleBodyScroll);
            document.removeEventListener('click', handleCloseDropdownOnPageClick);
        };
    }, [dropdownOpened]);
    return (<div ref={autocompleteRef}>
      <Autocomplete_1.default open={dropdownOpened} filterOptions={filterOptions} noOptionsText={options.invalidOption} onChange={function (_, option) { return handleOnChange(option); }} onOpen={function () { var _a; return !((_a = schema) === null || _a === void 0 ? void 0 : _a.readOnly) && setDropdownOpen(true); }} onClose={function () { return setDropdownOpen(false); }} classes={{
        input: styles.input,
        noOptions: styles.noOptions,
        listbox: styles.listbox,
        option: styles.option,
        paper: styles.paper,
    }} id={id} options={options.enumOptions} getOptionLabel={function (option) { return option.label; }} disableClearable={(_b = schema) === null || _b === void 0 ? void 0 : _b.readOnly} defaultValue={defaultValue} data-test={"autocomplete_input:" + id} renderInput={function (params) {
        var _a;
        var inputProps = {
            label: label,
            required: required,
            id: id,
            value: value,
            params: params,
            placeholder: placeholder,
            tooltip: options.tooltip,
            readOnly: (_a = schema) === null || _a === void 0 ? void 0 : _a.readOnly,
            endAdornment: (<core_1.InputAdornment position="end">
                {showDropdownIcon && (<icons_1.KeyboardArrowDown onClick={function () { return setDropdownOpen(true); }} className={styles.arrowDownIconButton}/>)}
              </core_1.InputAdornment>),
        };
        if (options.displayKeyOnSelect && !dropdownOpened) {
            params.inputProps = __assign(__assign({}, params.inputProps), { value: value });
            return <GenericInput_1.default {...inputProps}/>;
        }
        return <GenericInput_1.default {...inputProps}/>;
    }}/>
    </div>);
};
exports.default = AutocompleteInput;
